export default "__VITE_ASSET__DpoSEDqz__"